import React, { useRef, MouseEventHandler, FC } from 'react';
import cn from 'classnames';
import { getDotsStatus } from '../helpers/getDotsStatus';
require("./Slider-Dots.css");
var styles = {
  "Root": "Slider-Dots-module-Root_RCd",
  "List": "Slider-Dots-module-List_37Q",
  "Control": "Slider-Dots-module-Control_dx8",
  "Dot": "Slider-Dots-module-Dot_aU9",
  "isMuted": "Slider-Dots-module-isMuted_3mG"
};
const noop = _e => {};
const Dots = ({
  dotsToShow = 5,
  length,
  selectedIndex = 0,
  setSelectedIndex = noop,
  slidesToScroll = 1
}) => {
  const _shift = useRef(0);
  const {
    shiftIndex,
    visibleArea
  } = getDotsStatus(selectedIndex / slidesToScroll, _shift.current, length, dotsToShow);
  _shift.current = shiftIndex;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Root,
    style: {
      width: `${Math.min(length, dotsToShow) * 22}px`
    }
  }, /*#__PURE__*/React.createElement("ul", {
    role: "tablist",
    className: styles.List,
    style: {
      transform: `translate3d(-${shiftIndex * 22}px, 0, 0)`
    }
  }, [...Array(length).keys()].map(index => /*#__PURE__*/React.createElement("li", {
    role: "tab",
    key: index,
    "aria-hidden": visibleArea[index - shiftIndex] === undefined,
    "aria-selected": visibleArea[index - shiftIndex] === 2,
    className: cn(styles.Dot, {
      [styles.isMuted]: index >= shiftIndex && visibleArea[index - shiftIndex] === 0
    })
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    value: index * slidesToScroll,
    onClick: setSelectedIndex,
    className: styles.Control,
    tabIndex: visibleArea[index - shiftIndex] === undefined ? -1 : 0
  }, index * slidesToScroll, " \u0438\u0437 ", length)))));
};
export default Dots;